import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRbacStore } from '../store/rbacStore';

/**
 * Route-level authorization guard.
 *
 * Wrap a route element so a user who lacks the permission cannot reach the
 * screen by typing its URL — they are redirected to /401 instead. The API is
 * still the real authority; this only keeps navigation honest.
 *
 * Fails OPEN, mirroring the sidebar: if permissions are unknown (never loaded,
 * or the fetch failed) we render the screen rather than locking the user out of
 * the whole app. Full-access roles (Super Admin / Reporting Manager / HR Admin)
 * pass automatically via hasPermission().
 */
export function RequirePermissionRoute({
  moduleName,
  resource,
  action = 'View',
  children,
}: {
  moduleName: string;
  resource: string;
  action?: string;
  children: React.ReactNode;
}) {
  const hasPermission = useRbacStore((s) => s.hasPermission);
  const dataAvailable = useRbacStore((s) => s.isPermissionDataAvailable());

  if (!dataAvailable) return <>{children}</>;
  if (hasPermission(moduleName, resource, action)) return <>{children}</>;
  return <Navigate to="/401" replace />;
}
